var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container page"},[_c('h1',[_vm._v(_vm._s(_vm.$t('nav.service_faq')))]),_c('p',[_vm._v("常见问题示例。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }